const baseUrl = "/i18n"

export const apiPaths = {
    getLocale: (locale: string) => `/i18n/${locale}`,
    modules: `${baseUrl}/modules`,
}

export interface LocalisationData {
    id: string
    key: string
    value?: string | null
}

export interface LocalisationModule {
    key: string
}
